import { render } from "./MatrixAccountGroup.vue?vue&type=template&id=0bce280e&scoped=true"
import script from "./MatrixAccountGroup.vue?vue&type=script&lang=js"
export * from "./MatrixAccountGroup.vue?vue&type=script&lang=js"

import "./MatrixAccountGroup.vue?vue&type=style&index=0&id=0bce280e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bce280e"]])

export default __exports__